export default __webpack_public_path__ + "static/project-slide-3-768-700-2e5b611b1eea8b376ecab29c3ee57903.webp";